// src/__internal__/activity/findLatestActiveActivity.ts
function isActivityNotExited(activity) {
  return !activity.exitedBy;
}
function compareActivitiesByEventDate(a1, a2) {
  return a2.enteredBy.eventDate - a1.enteredBy.eventDate;
}
function findLatestActiveActivity(activities) {
  return activities.filter(isActivityNotExited).sort(compareActivitiesByEventDate)[0];
}
export {
  findLatestActiveActivity
};
